import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
	createStyles({
		titleAndActions: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			gap: '1.5rem'
		}
	})
);

export interface ITitleAndActionsContainerProps {
	children?: React.ReactNode;
}

const TitleAndActionsContainer: React.FunctionComponent<ITitleAndActionsContainerProps> = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.titleAndActions}>{children}</div>;
};

export default TitleAndActionsContainer;
